<div class="container-fluid p-0">
  <div class="row g-0">
    <div class="col-xl-9">
      <div class="auth-full-bg pt-lg-5 p-4">
        <div class="w-100">
          <div class="bg-overlay"></div>
          <div class="d-flex h-100 flex-column">
            <div class="p-4 mt-auto">
              <div class="row justify-content-center">
                <div class="col-lg-7"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-3">
      <div class="auth-full-page-content p-md-5 p-4">
        <div class="w-100">
          <div class="d-flex flex-column h-100">
            <div class="mb-4 mb-md-5">
              <a routerLink="/" class="d-block auth-logo d-flex justify-content-center align-items-center">
                <!-- <img src="assets/images/logo-cloud.png" alt="" height="18" class="auth-logo-dark" /> -->
                <img src="assets/images/logo-next.svg" />
                <!-- <object type="image/svg+xml" data="assets/images/logo-next.svg">
                  <img src="assets/images/logo-next.svg" />
                </object> -->
              </a>
            </div>
            <div class="my-auto">
              <!-- <div>
                <h5 class="text-primary">Welcome Back !</h5>
              </div> -->
              <form [formGroup]="loginForm" (ngSubmit)="authenticateUser()" autocomplete="on">
<!--                <div class="row">-->
<!--                  <div class="plans">-->
<!--                    <label class="plan basic-plan" for="portal">-->
<!--                      <input checked type="radio" name="selectedPortal" id="portal" formControlName="selectedPortal"-->
<!--                        value="portal" />-->
<!--                      <div class="plan-content">-->
<!--                        <i class="mdi mdi-warehouse"></i>-->
<!--                        <div class="plan-details">-->
<!--                          <span>Portal</span>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </label>-->

<!--                    <label class="plan complete-plan" for="crm">-->
<!--                      <input type="radio" id="crm" name="selectedPortal" formControlName="selectedPortal" value="crm" />-->
<!--                      <div class="plan-content">-->
<!--                        <i class="mdi mdi-application-settings"></i>-->
<!--                        <div class="plan-details">-->
<!--                          <span>CRM</span>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </label>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="row">-->
<!--                  <div class="col-md-12">-->
<!--                  <div class="plans">-->
<!--                    <label class="plan complete-plan" for="moneytransfer" style="width: 100%;">-->
<!--                      <input type="radio" id="moneytransfer" name="selectedPortal" formControlName="selectedPortal"-->
<!--                        value="moneytransfer" />-->
<!--                      <div class="plan-content">-->
<!--                        <i class="mdi mdi-bank-transfer"></i>-->
<!--                        <div class="plan-details">-->
<!--                          <span>Money Transfer</span>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </label>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

                <div class="mt-4">
                  <div class="row mb-4">
                    <div class="col-md-4">
                      <label class="control-label text-white-50 align-self-center mb-0" for="loginas">Login As</label>
                      <select class="form-control bg-transparent text-white-50" formControlName="ddlLoginAs" >
                        <option style="color: black">Client</option>
                        <option style="color: black">Customer</option>
                        <!-- <option>Vendor</option> -->
                      </select>
                    </div>
                  </div>
                  <!-- <div class="form-group mb-3">
                              <label for="loginas">Login As</label>
                    </div> -->
                  <div class="mb-4 form-group">
                    <input #clientId type="text" class="form-control" id="clientid" 
                    formControlName="txtClientId" 
                    (keydown.enter)="email.focus()"
                    
                    [ngClass]="{
                          'is-invalid': loginSubmitted && l.txtClientId.errors
                        }" maxlength="50" placeholder=""/>
                    <label for="clientid" class="form-label">Client Id</label>
                    <div *ngIf="(loginSubmitted || l.txtClientId.touched) && l.txtClientId.errors" class="invalid-feedback">
                      <div *ngIf="l.txtClientId.errors.required">
                        Client id is required
                      </div>
                    </div>
                  </div>
                  <div class="mb-4 form-group">
                    <input #email type="email" class="form-control" id="email" formControlName="email" placeholder="" autocomplete="false" 
                      [ngClass]="{'is-invalid': loginSubmitted && l.email.errors}" (keyup.enter)="validateEmail()"/>
                    <label for="email" class="form-label">Email</label>
                      
                    <div *ngIf="loginSubmitted && l.email.errors" class="invalid-feedback">
                      <div *ngIf="l.email.errors.required">
                        Email is required
                      </div>
                      <div *ngIf="l.email.errors.pattern">
                        Email must be a valid email address
                      </div>
                    </div>
                  </div>
                  <div *ngIf="checkingEmail" class="mb-4 form-group d-flex justify-content-center">
                    <div class="spinner-border text-warning m-1" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>

                  <ng-container *ngIf="loadPwdSections">
                    <ng-container *ngIf="firstLogin">
                      <div class="mb-4 form-group">
                        <input type="{{ hidePassword ? 'password' : 'text' }}" class="form-control" autocomplete="new-password" 
                           (keydown.enter)="cnfPwd.focus()"
                          formControlName="txtPassword" [ngClass]="{
                              'is-invalid': loginSubmitted && l.txtPassword.errors
                            }" aria-label="Password" aria-describedby="password-addon" placeholder="" />
                        <label for="password"  class="form-label">Password</label>
                        <button
                          class="btn bg-transparent text-white border position-absolute top-0 border-opacity-50 form-icon"
                          type="button" id="btnpassword" (click)="hidePassword=!hidePassword">
                          <i [class]="hidePassword ? 'mdi mdi-eye-outline' : 'mdi mdi-eye-off-outline' "></i>
                        </button>
                        <div *ngIf="loginSubmitted && l.txtPassword.errors" class="invalid-feedback">
                          <span *ngIf="l.txtPassword.errors.required">Password is required</span>
                          <span *ngIf="l.txtPassword.errors.maxlength"> Maximum length exceeded (20 characters).</span>
                          <span *ngIf="l.txtPassword.errors.minlength"> Must be at least 8 characters long.</span>
                          <span *ngIf="l.txtPassword.errors.requiresSpecialChars">Must contain at least 1 special character.</span>
                          <span *ngIf="l.txtPassword.errors.requiresDigit">Must contain at least 1 digit.</span>
                          <span *ngIf="l.txtPassword.errors.requiresUppercase">Must contain at least 1 uppercase.</span>
                          <span *ngIf="l.txtPassword.errors.requiresLowercase">Must contain at least 1 lowercase.</span>
                          <span *ngIf="l.txtPassword.errors.usernamePasswordSame">Username and Password can not be same.</span>
                        </div>

                      </div>

                      <div class="mb-4 form-group">
                        <input #cnfPwd type="{{ hideConfirmPassword ? 'password' : 'text' }}" class="form-control" 
                          formControlName="txtConfirmPassword" [ngClass]="{
                              'is-invalid': loginSubmitted && l.txtConfirmPassword.errors
                            }" aria-label="Confirm Password" aria-describedby="password-addon" placeholder="" />
                        <label for="confirmpassword" class="form-label">Confirm Password</label>
                        <button
                          class="btn bg-transparent text-white border position-absolute top-0 border-opacity-50 form-icon"
                          type="button" id="btnconfirmpassword" (click)="hideConfirmPassword=!hideConfirmPassword">
                          <i [class]="hideConfirmPassword ? 'mdi mdi-eye-outline' : 'mdi mdi-eye-off-outline' "></i>
                        </button>
                        <div *ngIf="loginSubmitted && l.txtConfirmPassword.errors" class="invalid-feedback">
                          <span *ngIf="l.txtConfirmPassword.errors.required">Confirm Password is required</span>
                          <span *ngIf="l.txtConfirmPassword.errors.minlength"> Minimum 8 characters long.</span>
                          <span *ngIf="l.txtConfirmPassword.value && l.txtConfirmPassword.errors?.mismatch" class="custom-error-message">
                              Passwords doesn't match.
                          </span>
                        </div>

                      </div>

                    </ng-container>

                    <ng-container *ngIf="!firstLogin">
                      <div class="mb-4 form-group">
                        <input type="{{ hidePassword ? 'password' : 'text' }}" class="form-control" autocomplete="new-password" 
                           (keydown.enter)="submitBtn.focus()"
                          formControlName="password" [ngClass]="{
                              'is-invalid': loginSubmitted && l.password.errors
                            }" aria-label="Password" aria-describedby="password-addon" placeholder=""  />
                        <label for="password" class="form-label">Password</label>
                        <button
                          class="btn bg-transparent text-white border position-absolute top-0 border-opacity-50 form-icon"
                          type="button" id="password" (click)="hidePassword=!hidePassword">
                          <i [class]="hidePassword ? 'mdi mdi-eye-outline' : 'mdi mdi-eye-off-outline' "></i>
                        </button>
                        <div *ngIf="loginSubmitted && l.password.errors" class="invalid-feedback">
                          <span *ngIf="l.password.errors.required">Password is required</span>
                        </div>
                      </div>
                    </ng-container>
                    
                    <div class="d-flex justify-content-between">
                      <!-- <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="remember-check"
                          />
                          <label
                            class="form-check-label text-white-50"
                            for="remember-check"
                          >
                            Remember me
                          </label>
                        </div> -->
                      <div class="float-end">
                        <a routerLink="/account/forgot-password" class="text-white-50">Forgot password?</a>
                      </div>
                    </div>
  
                    <div class="mt-3 d-grid">
                      <button #submitBtn class="btn login-btn btn-block" type="submit">
                        Log In
                      </button>
                    </div>
                  </ng-container>
                  
                </div>
              </form>
            </div>

            <div class="mt-4 mt-md-5 text-center">
              <p class="mb-0 text-white-50">
                © {{ year }} Powered by
                <img width="100" src="assets/images/busisoft_logo.png" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>